var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardClock = function SvgCreditCardClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6V4a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v2m18 0v1.5M19 6H1m8 9H4a3 3 0 0 1-3-3V6m2.99 5H4m3 0h2m6.778 1.5V14l1.333 1.333M20 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCreditCardClock;